import {
  TIMELINE_TODAY_OVERLAP_PX,
  TIMELINE_TRACK_INSET_PX,
} from "constants/filingsTimeline";
import { TimelineMarkerGroup } from "./groupFilingsByProximity";

export const isTodayOverlappingDate = (
  groups: TimelineMarkerGroup[],
  todayFraction: number,
  trackWidth: number
): boolean => {
  const usableWidth = trackWidth - TIMELINE_TRACK_INSET_PX * 2;

  // Unmeasured track (first paint): keep Today on the date row.
  if (usableWidth <= 0) return false;

  return groups.some(
    ({ fraction }) =>
      Math.abs(fraction - todayFraction) * usableWidth <
      TIMELINE_TODAY_OVERLAP_PX
  );
};
